import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/diagnostic-report";



// Lấy kết quả theo ServiceRequestItem
export const getByServiceRequestItemId = (serviceRequestItemId) =>
  axios.get(API_PATH + "/get-by-sri-id/" + serviceRequestItemId);

// Lấy kết quả theo ServiceRequestItem, nếu chưa có thì tạo mới
export const getOrCreateNewByServiceRequestItemId = (serviceRequestItemId) =>
  axios.get(API_PATH + "/get-or-create-new-by-sri-id/" + serviceRequestItemId);

// Hủy tạo kết quả điều trị, đưa về trạng thái chưa bắt đầu điều trị
export const undoCreateNewDiagnosticReport = (diagnosticReportId) =>
  axios.delete(
    API_PATH + "/undo-create-diagnostic-report/" + diagnosticReportId
  );

// Hủy tạo kết quả điều trị, đưa về trạng thái chưa bắt đầu điều trị theo serviceRequestItemId
export const undoCreateNewDiagnosticReportByServiceRequestItemId = (
  serviceRequestItemId
) =>
  axios.delete(
    API_PATH +
      "/undo-create-diagnostic-report-by-sri-id/" +
      serviceRequestItemId
  );

// Cập nhật kết quả điều trị
export const saveDiagnosticReportByServiceRequestItem = (dto) =>
  axios.post(API_PATH + "/save-diagnostic-report-by-sri", dto);

// Đánh dấu dịch vụ là đã hoàn thành
export const markServiceAsCompletedByServiceRequestItem = (
  serviceRequestItemId
) => axios.post(API_PATH + "/mark-sri-as-completed/" + serviceRequestItemId);

// Đánh dấu nhiều dịch vụ là đã hoàn thành
export const markMultipleServiceAsCompletedByServiceRequestItem = (dto) =>
  axios.post(API_PATH + "/mark-multiple-sri-as-completed", dto);

// HỦY ĐÁNH DẤU lần điều trị là đã hoàn thành
export const undoMarkServiceAsCompletedByServiceRequestItem = (
  serviceRequestItemId
) =>
  axios.post(API_PATH + "/undo-mark-sri-as-completed/" + serviceRequestItemId);

// HỦY ĐÁNH DẤU NHIỀU lần điều trị là đã hoàn thành = Đánh dấu dịch vụ đã hoàn thành là chưa hoàn thành
export const undoMarkMultipleServiceAsCompletedByServiceRequestItem = (dto) =>
  axios.post(API_PATH + "/undo-mark-multiple-sri-as-completed", dto);

//Lấy định mức san phẩn, vật tư theo Id cả chỉ định dịch vụ
export const getDiagnosticReportWithMaterialStandardsBySriId = (
  serviceRequestItemId
) =>
  axios.get(
    API_PATH +
      "/get-diagnostic-report-with-material-standards-by-sri-id/" +
      serviceRequestItemId
  );

// Cập định mức sản phẩm, vật tư theo kết quả điều trị
export const saveDiagnosticReportWithMaterialStandards = (dto) =>
  axios.post(API_PATH + "/save-diagnostic-report-with-material-standards", dto);
export const getOrCreateNewByListSriId = (dto) =>
  axios.post(API_PATH + "/get-or-create-new-by-list-sri-id", dto);
